<template>


  <!-- =============================== header 1 ===============================  -->
  <section class="bg-purple">
    <div class="container mx-auto px-5 md:px-20 py-2">
      <div class="flex">
        <div class="w-10/12 p-2 text-center my-auto">
          <img  src="@/assets/images/weentregas/full-logo.png" alt="">
        </div>
        <div class="w-2/12 p-2 my-auto">
          <div class="flex items-center sm:justify-center md:justify-end justify-center mt-5 sm:mt-0">
            <img class="md:pr-4" :src="getAvatar(user.email)" width="60px" alt="" @click="openNav">
            <div id="mySidenav" class="sidenav">
              <a href="javascript:void(0)" class="closebtn" @click="closeNav">&times;</a>
              <a href="#" @click="inicio">Encomendas</a>
              <a href="#" @click="sair">Sair</a>
            </div>
            <p class="hidden lg:block text-white font-bold Arial text-base">{{user.nome}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
  export default {
    name: "topo",
    props: ['user'],
    methods: {
      getAvatar(email){
        if (email){
          let md5 = require('md5');
          email = email.trim();
          email = md5(email);
          console.log('email aí', email)
          return `https://www.gravatar.com/avatar/${email}?d=` + encodeURIComponent('https://api.saveleads.com.br/images/avatar-padrao.png');
        }
      },
      openNav() {
        document.getElementById("mySidenav").style.width = "250px";
      },
      closeNav() {
        document.getElementById("mySidenav").style.width = "0";
      },
      inicio(){
        this.$router.push({name: 'inicio'})
      },
      sair(){
        localStorage.removeItem('weeLogged')
        this.$router.push({name: 'login'})
      }
    }
  }
</script>

<style scoped>

</style>
